/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
    overlay: {
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        position: 'absolute',
        background: 'rgba(255, 255, 255, 0.8)',
    },
}));

const Overlay = () => {
    const classes = useStyles();

    return (
        <div className={classes.overlay} />
    );
};

export default Overlay;
